import React, { useEffect, useState } from "react"
import Breadcrumbs from "../../../components/Common/Breadcrumb"
import { useDispatch, useSelector } from "react-redux"
import DeleteModal from "components/Common/DeleteModal"
import CommodityClassificationListComponent from "components/CommodityClassification/list"
import {
  deleteCommodityClassification,
  exportCommodityClassifications,
  getCommodityClassifications,
} from "store/commodity-classification/commodity-classification-action"

const CommodityClassificationList = () => {
  const dispatch = useDispatch()
  const { data, loading, exportStatus } = useSelector(
    state => state.commodityClassification
  )
  const [deleteModal, setDeleteModal] = useState(false)
  const [selectedRecord, setSelectedRecord] = useState(null)
  const [search, setSearch] = useState(null)
  const [pageNumber, setPageNumber] = useState(10)
  const [according, setAccording] = useState({ order: "desc", name: "id" })

  const handleDeleteFunc = () => {
    if (selectedRecord) {
      dispatch(deleteCommodityClassification(selectedRecord.id))
    }
    setDeleteModal(false)
  }

  const onClickDelete = data => {
    setSelectedRecord(data)
    setDeleteModal(true)
  }

  const onPageClick = link => {
    dispatch(
      getCommodityClassifications(link.url, pageNumber, according, search)
    )
  }

  useEffect(() => {
    const delayDebounceFn = setTimeout(() => {
      dispatch(
        getCommodityClassifications(undefined, undefined, undefined, search)
      )
    }, 1500)

    return () => clearTimeout(delayDebounceFn)
  }, [dispatch, search])

  useEffect(() => {
    dispatch(
      getCommodityClassifications(undefined, pageNumber, according, search)
    )
  }, [dispatch, pageNumber, according, search])

  return (
    <>
      <DeleteModal
        show={deleteModal}
        onDeleteClick={handleDeleteFunc}
        onCloseClick={() => setDeleteModal(false)}
      />
      <Breadcrumbs title={"Admin"} breadcrumbItem={"Unit Classification"} />
      <CommodityClassificationListComponent
        data={data}
        loading={loading}
        onClickDelete={onClickDelete}
        onPageClick={onPageClick}
        onSearch={setSearch}
        onChangeRowNumber={setPageNumber}
        onChangeOrdering={value => {
          if (value.order) {
            setAccording(prev => ({ ...prev, order: value.order }))
          }
          if (value.name) {
            setAccording(prev => ({ ...prev, name: value.name }))
          }
        }}
        onExportBtnClick={() =>
          dispatch(exportCommodityClassifications(search))
        }
        exportStatus={exportStatus}
      />
    </>
  )
}

export default CommodityClassificationList
